import startCase from 'lodash/startCase';

/**
 * What the Lens panel offers on each page before the user types: the page's name for the greeting
 * and up to three starter questions. Keyed by route name; a page inherits from the nearest matched
 * route that has an entry (a chart tab uses `patient`), and anything unlisted gets DEFAULT_PAGE.
 *
 * `label` overrides the route's own label where that reads badly in a sentence; `starters` is an
 * optional list of questions. No page has starters yet.
 */
const LENS_PANEL_PAGES = {
    patient: { label: 'a client chart' },
};

const DEFAULT_PAGE = {};

const MAX_STARTERS = 3;

function entryFor(route) {
    const matched = [...(route?.matched ?? [])].reverse();
    const name = matched.map((record) => record.name).find((n) => n && LENS_PANEL_PAGES[n]);
    return name ? LENS_PANEL_PAGES[name] : null;
}

/** The page's name as the browser tab shows it: the route's label, else its name in start case. */
export function pageTitle(route) {
    const label = route?.meta?.label;
    return typeof label === 'string' && label ? label : startCase(String(route?.name ?? ''));
}

/** The greeting's name for the page and the starters to offer there. */
export function lensPanelPage(route) {
    const entry = entryFor(route) ?? DEFAULT_PAGE;
    return { label: entry.label ?? pageTitle(route), starters: (entry.starters ?? []).slice(0, MAX_STARTERS) };
}
